import paper from 'paper';
import angleToVectorPoint from '@utils/angleToVectorPoint';
import lineSegmentIntersection from '@utils/lineSegmentIntersection';

const isGradient = (color) => {
  return !!color.type && color.type !== 'rgb';
}

const createLineSegment = (figureBounds) => {
  const { width, height, x, y } = figureBounds;
  const topLineSegment = [ { x, y }, {x: x + width, y} ];
  const bottomLineSegment = [
    { x, y: y + height },
    {x: x + width, y: y + height}
  ];

  const leftLineSegment = [ { x, y }, { x, y: y + height} ];
  const rightLineSegment = [ 
    { x: x + width, y },
    { x: x + width, y: y + height}
  ];

  return {
    top: topLineSegment,
    bottom: bottomLineSegment,
    left: leftLineSegment,
    right: rightLineSegment,
  }
}

export default (figure, color) => {
  if (!isGradient(color)) {
    return new paper.Color(color.red/255, color.green/255, color.blue/255, color.alpha);
  }

  const { width, height, x, y } = figure.bounds;
  const gradient = {
    stops: color.points.map((point) => new paper.GradientStop(
      new paper.Color(point.red/255, point.green/255, point.blue/255, point.alpha),
      point.left/100
    )),
    radial: color.type !== 'linear'
  };

  if (color.type === 'linear') {
    const figureCenter = {
      x: x + Math.round(width/2),
      y: y + Math.round(height/2)
    }

    const degree = color.degree + 90;
    const vectorPoint = angleToVectorPoint(degree);
    const doubleMaxLength = Math.max(width, height) * 2;
    const pointForFindIntersection = {
      x: vectorPoint.x * doubleMaxLength,
      y: vectorPoint.y * doubleMaxLength,
    };

    const gradientLineForFindIntersection = [
      {
        x: Math.floor(figureCenter.x - pointForFindIntersection.x),
        y: Math.floor(figureCenter.y - pointForFindIntersection.y),
      },
      {
        x: Math.ceil(figureCenter.x + pointForFindIntersection.x),
        y: Math.ceil(figureCenter.y + pointForFindIntersection.y),
      },
    ]
    const figureLineSegments = createLineSegment(figure.bounds);

    const topIntersection = lineSegmentIntersection(gradientLineForFindIntersection, figureLineSegments.top);
    const bottomIntersection = lineSegmentIntersection(gradientLineForFindIntersection, figureLineSegments.bottom);
    const leftIntersection = lineSegmentIntersection(gradientLineForFindIntersection, figureLineSegments.left);
    const rightIntersection = lineSegmentIntersection(gradientLineForFindIntersection, figureLineSegments.right);

    let originPoint, destinationPoint;
    if (topIntersection) {
      if (!bottomIntersection) return;
      originPoint = topIntersection;
      destinationPoint = bottomIntersection;
      if ((degree > 360 || degree < 180)) {
        [originPoint,destinationPoint] = [destinationPoint, originPoint]
      }
    } else {
      if (!leftIntersection || !rightIntersection) return;
      originPoint = leftIntersection;
      destinationPoint = rightIntersection;
      if (!(degree > 90 && degree < 270)) {
        [originPoint,destinationPoint] = [destinationPoint, originPoint]
      }
      // if (topIntersection || bottomIntersection) {
      //   [originPoint,destinationPoint] = [destinationPoint, originPoint]
      // }
    }

    return  {
      gradient: gradient,
      origin: [ Math.round(originPoint.x), Math.round(originPoint.y) ],
      destination: [ Math.round(destinationPoint.x), Math.round(destinationPoint.y) ],
    }
  } else {
    return {
      gradient: gradient,
      destination: [ x, y ],
      origin: [ x + Math.round(width/2), y + Math.round(height/2)],
    }
  }
}